import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CoordinatesSystem, ImageFormat, NoBreakpoints } from '../../../../state-management/model/enums/screen-size.enums';
import { ImageCoordinates } from '../../../../state-management/model/interfaces/screen-size.model';
import { EditableImageComponent } from '../../../base/image/editable-image/editable-image.component';
import { FileType } from '../../../../state-management/model/enums/state.enums';
import { EditableTextComponent } from '../../../base/text/editable-text/editable-text.component';
import { BaseComponent } from '../../base/base.component';

@Component({
    selector: 'app-base-cards-gallery',
    imports: [
        EditableImageComponent,
        EditableTextComponent
    ],
    templateUrl: './base-cards-gallery.component.html',
    styleUrl: './base-cards-gallery.component.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseCardsGalleryComponent extends BaseComponent {
  readonly hasDescription = input<boolean>(true);
  
  public supportedFileTypes = [FileType.WEBP, FileType.JPEG];
  
  override labelMap = {
    title: 'title',
    description: 'description',
    image: 'image'
  };

  override imageReference: ImageCoordinates = {
    coordinatesSystem: CoordinatesSystem.NoCoordinates,
    formatMap: {
      [NoBreakpoints.Unset]: ImageFormat.OneToOne
    }
  };
}